export const INITIAL_VALUES = {
  activeFrom: undefined,
  activeTo: undefined,
  additionalRequirements: '',
  companyId: '',
  currencyId: '',
  employmentTypeIds: [],
  mandatoryRequirements: '',
  name: '',
  paymentPeriodId: '',
  cityIds: [],
  responsibleUserId: '',
  responsibilities: '',
  salaryFrom: undefined,
  salaryTo: undefined,
  scheduleWorkIds: [],
  skills: [],
  activitySphereIds: [],
  ai_sphere_fill: true,
  requiredCandidatesCount: '',
  tariffId: '',
  interviewFinalMessage: '',
};
